import { LayoutsHome } from "../layouts";
import { CustomLayout } from "../components/layouts";

import { DistributionPage } from "../modules/modules.dispatches/pages.dispatches/DistributionPage";
import { SupplyingPage } from "../modules/modules.dispatches/pages.dispatches/SupplyingPage";
import { DevolutionPage } from "../modules/modules.dispatches/pages.dispatches/DevolutionPage";
import { ReadjustmentPage } from "../modules/modules.dispatches/pages.dispatches/ReadjustmentPage";
import { AccumulativeDispatchPage } from "../modules/modules.dispatches/pages.dispatches/AccumulativeDispatchPage";
import { MapPage } from "../modules/modules.dispatches/pages.dispatches/MapPage";
import { OrderTrayPage } from "../modules/modules.dispatches/pages.dispatches/OrderTrayPage";
import { SaleStatisticPage } from "../modules/modules.dispatches/pages.dispatches/SaleStatisticPage";
import { DailyRouteGraphByDayPage } from "../modules/modules.dispatches/pages.dispatches/DailyRouteGraphByDayPage";
import { SoldProductGraphByDayPage } from "../modules/modules.dispatches/pages.dispatches/SoldProductGraphByDayPage";
import { ClientPortfolioPage } from "../modules/modules.dispatches/pages.dispatches/ClientPortfolioPage";
import { SpecialSalePage } from "../modules/modules.dispatches/pages.dispatches/SpecialSalePage";

const routesDISPATCHES = [
  {
    path: "/dispatches/distributions",
    layout: CustomLayout,
    component: DistributionPage,
  },
  {
    path: "/dispatches/supplyings",
    layout: CustomLayout,
    component: SupplyingPage,
  },
  {
    path: "/dispatches/devolutions",
    layout: CustomLayout,
    component: DevolutionPage,
  },
  {
    path: "/dispatches/readjustments",
    layout: CustomLayout,
    component: ReadjustmentPage,
  },
  {
    path: "/dispatches/accumulative_dispatches",
    layout: CustomLayout,
    component: AccumulativeDispatchPage,
  },
  {
    path: "/dispatches/map_clients",
    layout: CustomLayout,
    component: MapPage,
  },
  {
    path: "/dispatches/order_tray",
    layout: CustomLayout,
    component: OrderTrayPage,
  },
  {
    path: "/dispatches/sales_statistics",
    layout: CustomLayout,
    component: SaleStatisticPage,
  },
  {
    path: "/dispatches/daily_route_graph_by_day",
    layout: CustomLayout,
    component: DailyRouteGraphByDayPage,
  },
  {
    path: "/dispatches/sold_product_graph_by_day",
    layout: CustomLayout,
    component: SoldProductGraphByDayPage,
  },
  {
    path: "/dispatches/client_portfolios",
    layout: CustomLayout,
    component: ClientPortfolioPage,
  },
  {
    path: "/dispatches/special_sales",
    layout: CustomLayout,
    component: SpecialSalePage,
  },

];
export default routesDISPATCHES;
